var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4784 27.6595C37.4784 30.9417 34.8085 33.6074 31.5305 33.6074H12.0164C8.73841 33.6074 6.06845 30.9416 6.06845 27.6595V15.2429C6.06845 14.1475 6.36839 13.1186 6.889 12.2356L16.4107 21.7573C17.8352 23.186 19.7428 23.9732 21.7755 23.9732C23.804 23.9732 25.7116 23.186 27.1361 21.7573L36.6578 12.2356C37.1785 13.1186 37.4783 14.1474 37.4783 15.2429V27.6595H37.4784ZM31.5304 9.29502H12.0164C10.6627 9.29502 9.41313 9.75315 8.4135 10.5154L18.031 20.1371C19.0265 21.1283 20.3551 21.6782 21.7755 21.6782C23.1917 21.6782 24.5204 21.1283 25.5158 20.1371L35.1333 10.5154C34.1337 9.75315 32.8842 9.29502 31.5304 9.29502ZM31.5304 7H12.0164C7.47217 7 3.77344 10.6987 3.77344 15.243V27.6596C3.77344 32.208 7.47217 35.9025 12.0164 35.9025H31.5304C36.0747 35.9025 39.7734 32.208 39.7734 27.6596V15.2429C39.7734 10.6987 36.0747 7 31.5304 7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.8653d8d75acedb5ea1a987a6f7ab2ed9.svg";
export { ForwardRef as ReactComponent };